import React from "react";
import type { MenuProps } from "antd";
import { voidFnc } from "./helpers";

interface FilterOption {
  key: string;
  label: string;
}

interface AllOptionConfig {
  key: string;
  label: string;
  checked: boolean;
}

export function buildCheckboxMenuItems(
  items: readonly FilterOption[],
  selectedKeys: string[],
  allOption: AllOptionConfig,
  idPrefix: string
): NonNullable<MenuProps["items"]> {
  const allItem = {
    key: allOption.key,
    icon: (
      <div>
        <input
          className="custom-checkbox"
          id={allOption.key}
          type="checkbox"
          onClick={e => e.stopPropagation()}
          checked={allOption.checked}
          onChange={voidFnc}
        />
        <label htmlFor={allOption.key} className="custom-checkbox-label">
          {allOption.label}
        </label>
      </div>
    )
  };

  const optionItems = items.map(({ key, label }) => {
    const optionId = `${idPrefix}-${key}`;
    const isSelected = selectedKeys.includes(key);
    return {
      key,
      icon: (
        <div>
          <input
            className="custom-checkbox"
            id={optionId}
            type="checkbox"
            onClick={e => e.stopPropagation()}
            checked={isSelected}
            onChange={voidFnc}
          />
          <label htmlFor={optionId} className="custom-checkbox-label">
            {label}
          </label>
        </div>
      )
    };
  });

  return [allItem, ...optionItems];
}
